import React, { useEffect } from "react";
import {useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import MetaData from "../../components/layout/MetaData";
import { useOrderDetailsQuery } from "../../redux/api/orderApi";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import BreadcrumbOrder from "../layout/Breadcrumb/breadcrumbInvoice";

/**
 * 发票页面组件：展示订单发票并支持下载 PDF。
 */
const Invoice = () => {
   const params = useParams();
   const { data, isLoading, error } = useOrderDetailsQuery(params.id);
  const order = data?.order || {};
  const orderDisplayId = order?.orderNo || order?._id;
  
   const { shippingInfo, orderItems, paymentInfo, user } = order;

   useEffect(() => {
     if (error) {
       toast.error(error?.data?.message);
     }
   }, [error]);

   /**
    * 下载发票：将当前发票区域截图后导出为 PDF。
    */
   const handleDownload = () => {
     const input = document.getElementById("order_invoice");
     html2canvas(input).then((canvas) => {
       const imgData = canvas.toDataURL("image/png");

       const pdf = new jsPDF();

       const pdfWidth = pdf.internal.pageSize.getWidth();
       pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, 0);
       pdf.save(`invoice_${orderDisplayId}.pdf`);
     });
   };

   if (isLoading) return <Loader />;
  return (
    <>
      <MetaData title={"Order Invoice"} />
      <BreadcrumbOrder />

      <div className="flex justify-center my-5">
        <div className="w-full max-w-4xl">
          <button className="btn btn-success mb-5" onClick={handleDownload}>
            <i className="fa fa-print"></i> Download Invoice
          </button>
          <div
            id="order_invoice"
            className="p-5 border border-gray-200 rounded-lg shadow"
          >
            <div
              key={order?._id}
              className="flex justify-between items-center mb-5"
            >
              <div id="logo">
                <img src="/img/invoice-logo.png" alt="Company Logo" />
              </div>
              <h1 className="text-2xl font-bold">Proforma Invoice: {orderDisplayId}</h1>
            </div>
            <div className="flex justify-between mb-5">
              <div>
                <p> Creatyea Technology (SZ) CO Limited</p>
                <p>
                  RM1903 - 1905, 19/F, Qiu Shi, West BLDG, Zhu Zi Lin,
                  Fu Tian Estate, Shen Zhen, 518031 GD, China.
                </p>
                <p>+86-13538239881</p>
                <p>
                  <a
                    href="mailto:hello@creatyea.com"
                    className="text-blue-600 hover:text-blue-800"
                  >
                    hello@creatyea.com
                  </a>
                </p>
              </div>
              <div>
                <p>
                  <span className="font-semibold">Name:</span> {user?.name}
                </p>
                <p>
                  <span className="font-semibold">EMAIL:</span> {user?.email}
                </p>
                <p>
                  <span className="font-semibold">PHONE:</span>{" "}
                  {shippingInfo?.phoneNo}
                </p>
                <p>
                  <span className="font-semibold">ADDRESS:</span>{" "}
                  {`${shippingInfo?.address}, ${shippingInfo?.city}, ${shippingInfo?.zipCode}, ${shippingInfo?.country}`}
                </p>
                <p>
                  <span className="font-semibold">DATE:</span>{" "}
                  {new Date(order?.createdAt).toLocaleString("en-US")}
                </p>
                <p>
                  <span className="font-semibold">Status:</span>{" "}
                  {paymentInfo?.status}
                </p>
              </div>
            </div>
            <table className="w-full mt-5 table-auto">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-2 text-left">ID</th>
                  <th className="px-4 py-2 text-left">NAME</th>
                  <th className="px-4 py-2 text-left">PRICE</th>
                  <th className="px-4 py-2 text-left">QTY</th>
                  <th className="px-4 py-2 text-left">TOTAL</th>
                </tr>
              </thead>
              <tbody>
                {orderItems?.map((item, _id) => (
                  <tr key={item?._id}>
                    <td className="px-4 py-2">
                      {item?.isQuoteItem
                        ? item?.quoteId?._id || item?.quoteId || item?.quoteSnapshot?.quoteNo || "QUOTE"
                        : item?.product?._id}
                    </td>
                    <td className="px-4 py-2">{item?.name}</td>
                    <td className="px-4 py-2">${item?.price}</td>
                    <td className="px-4 py-2">{item?.quantity}</td>
                    <td className="px-4 py-2">
                      ${item?.price * item?.quantity}
                    </td>
                  </tr>
                ))}
                <tr className="bg-gray-50">
                  <td
                    colSpan="4"
                    className="text-right px-4 py-2 font-semibold"
                  >
                    SUBTOTAL
                  </td>
                  <td className="px-4 py-2">${order?.itemsPrice}</td>
                </tr>
                <tr className="bg-gray-50">
                  <td
                    colSpan="4"
                    className="text-right px-4 py-2 font-semibold"
                  >
                    SHIPPING
                  </td>
                  <td className="px-4 py-2">${order?.shippingAmount}</td>
                </tr>
                <tr className="bg-gray-200">
                  <td colSpan="4" className="text-right px-4 py-2 font-bold">
                    GRAND TOTAL
                  </td>
                  <td className="px-4 py-2 font-bold">${order?.totalAmount}</td>
                </tr>
              </tbody>
            </table>
            <div className="text-left mt-5">
              <p className="notice">
                <span className="font-semibold">Warranty</span>
              </p>
              <p className="notice mt-2">
                Returns are normally accepted when completed within 30 days from
                date of shipment (30 days if product is defective). We will also
                accept exchanges for products of equal or greater value within
                30 days of the ship date as long as the products were originally
                purchased from Creatyea and are still in the original packaging.
              </p>
              <p className="notice mt-2">
                Only products originally shipped from Creatyea will be returned
                to Creatyea. All others will be promptly quarantined and disposed
                of or returned to the customer. By a Customer returning products
                to Creatyea, the Customer certifies that the products were
                purchased from Creatyea and there has been no substitution in
                whole or part of same
              </p>
              <p className="notice mt-2">
                Product from another supplier, distributor or other such source
                of the product. The return should be in the original packaging
                and in unused condition (except defective). ESD sensitive
                products should not be opened except under controlled conditions.
              </p>
            </div>
            <p className="text-center mt-5">
              Invoice was created on a computer and is valid without the
              signature and seal.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Invoice;
